import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import ComplementaryListTable from './Components/ComplementaryListTable'

const ComplementaryList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Complementary List</HeadingOne>
                    <AddItemBtn url="add-complementary" title="Add Complementary" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <ComplementaryListTable />
            </div>
        </PageBody>
    )
}

export default ComplementaryList
